export const accountsIdsRegex = /^(,|\s|-|\d)*(\d)+(,|\s|-|\d)*$/;
export const incorrectAccountIdsCharactersRegex = /[^\s\-,]*[^\s\-,\d]+[^\s\-,]*/;
export const maxAccountsPerTime = 500;
export const accountIdMaxLength = 15;
